export class AzureMarketplaceWebhookInputSubscriptionBeneficiary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "emailId",
            "baseName": "emailId",
            "type": "string",
            "format": "email"
        },
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "puid",
            "baseName": "puid",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureMarketplaceWebhookInputSubscriptionBeneficiary.attributeTypeMap;
    }
    constructor() {
    }
}
